import { createReducer, on } from '@ngrx/store';
import { PermissionWithRelations } from '@rappider/rappider-sdk';

import * as PermissionActions from './permission.actions';
import { orderBy } from 'lodash';

export const featureKey = 'permissions';

export interface State {
  data: PermissionWithRelations[];
  adminData: PermissionWithRelations[];
  loading: boolean;
  adminLoading: boolean;
  modalVisibility: boolean;
}

export const initialState: State = {
  data: [],
  adminData: [],
  loading: false,
  adminLoading: false,
  modalVisibility: false
};

export const reducer = createReducer(
  initialState,

  /* get */
  on(PermissionActions.GetPermissions, (state) => ({
    ...state,
    loading: true
  })),

  on(PermissionActions.GetPermissionsSuccessful, (state, action) => ({
    ...state,
    data: orderBy(action.permissions, 'createdDate', 'desc'),
    loading: false
  })),

  on(PermissionActions.GetPermissionsFailure, (state) => ({
    ...state,
    loading: false
  })),

  /* get admin permissions */
  on(PermissionActions.GetAdminPermissions, (state) => ({
    ...state,
    adminLoading: true
  })),

  on(PermissionActions.GetAdminPermissionsSuccessful, (state, action) => ({
    ...state,
    adminData: orderBy(action.permissions, 'createdDate', 'desc'),
    adminLoading: false
  })),

  on(PermissionActions.GetAdminPermissionsFailure, (state) => ({
    ...state,
    adminLoading: false
  })),

  /* update */
  on(PermissionActions.UpdatePermission, (state) => ({
    ...state,
    loading: true
  })),

  on(PermissionActions.UpdatePermissionSuccessful, (state, action) => {
    const updatedPermission = {
      ...state.data?.find(permission => permission.id === action.id),
      ...action.permission
    };

    return {
      ...state,
      data: state.data ? orderBy([
        ...state.data.filter(permission => permission.id !== action.id),
        updatedPermission
      ], 'createdDate', 'desc') : [updatedPermission],
      adminData: state.adminData ? orderBy([
        ...state.adminData.filter(permission => permission.id !== action.id),
        updatedPermission
      ], 'createdDate', 'desc') : [updatedPermission],
      loading: false,
      modalVisibility: false
    };
  }),

  on(PermissionActions.UpdatePermissionFailure, (state) => ({
    ...state,
    loading: false,
    modalVisibility: false
  })),

  /* delete */
  on(PermissionActions.DeletePermission, (state) => ({
    ...state,
    loading: true
  })),

  on(PermissionActions.DeletePermissionSuccessful, (state, action) => ({
    ...state,
    data: state.data ? [
      ...state.data.filter(permission => permission.id !== action.id)
    ] : [],
    adminData: state.adminData ? [
      ...state.adminData.filter(permission => permission.id !== action.id)
    ] : [],
    loading: false
  })),

  on(PermissionActions.DeletePermissionFailure, (state) => ({
    ...state,
    loading: false
  })),

  /* create */
  on(PermissionActions.CreatePermission, (state) => ({
    ...state,
    loading: true
  })),

  on(PermissionActions.CreatePermissionSuccessful, (state, action) => ({
    ...state,
    data: state.data ? orderBy([
      ...state.data,
      action.permission
    ], 'createdDate', 'desc') : [action.permission],
    adminData: state.adminData ? orderBy([
      ...state.adminData,
      action.permission
    ], 'createdDate', 'desc') : [action.permission],
    loading: false,
    modalVisibility: false
  })),

  on(PermissionActions.CreatePermissionFailure, (state) => ({
    ...state,
    loading: false,
    modalVisibility: false
  })),

  /* modal visibility */
  on(PermissionActions.ChangePermissionModalVisibility, (state, action) => ({
    ...state,
    modalVisibility: action.visibility
  })),

);
